export default __webpack_public_path__ + "static/media/circle-o-cross.60d5b81a.svg";